import { sortAlphabeticalDesc, sortBooleanTrueFirst } from '@front-app/util/sort';
import { FullDigest } from '../model';

export const sortDigestsByStatusAndName = (a: FullDigest, b: FullDigest): number => {
	const firstSortResult = sortBooleanTrueFirst(!a.isDeactivated, !b.isDeactivated);
	if (firstSortResult === 0) {
		return sortAlphabeticalDesc(a.digestName, b.digestName);
	}
	return firstSortResult;
};
